import riot from 'riot';
import { getEnv } from 'msc_modules/src/configs/environments';
import { Environment } from 'msc_modules/src/configs/globalConfig';

export default function (root = document) {
    const isProd = getEnv() === Environment.PROD;

    if (isProd && navigator.serviceWorker) {
        void import('workbox-window').then(({ Workbox }) => {
            const wb = new Workbox('/service-worker.js', { scope: '/' });

            wb.addEventListener('waiting', () => {
                wb.addEventListener('controlling', () => {
                    window.location.reload();
                });

                wb.messageSkipWaiting();
            });

            void wb.register();
        });
    }

    Array.from(root.querySelectorAll('.riot-mount')).forEach((el) => {
        try {
            let tag = riot.mount(el);
            if (tag.length) {
                el.classList.remove('riot-mount');
            }
        } catch (e) {
            /* webpack-strip-block:removed */
        }
    });
}
